import * as yup from "yup";
import { FormValidationModel } from "../../models/validation";

export interface TemplateData {
    body: string;
    description: string | null;
    id: number;
    name: string;
    subject: string;
    typeId: number | null;
}

export class Template implements FormValidationModel<TemplateData> {
    public data: TemplateData;
    public rules: yup.Schema<TemplateData>;

    public constructor() {
        this.data = {
            body: "",
            description: null,
            id: 0,
            name: "",
            subject: "",
            typeId: null,
        };
        this.rules = yup.object<TemplateData>().shape({
            body: yup.string().required().nullable(true).label("Body"),
            description: yup.string().nullable(true).max(1000).label("Description"),
            id: yup.number().required().label("ID").min(0, "Invalid ID"),
            name: yup.string().required().nullable(true).max(255).label("Name"),
            subject: yup.string().required().nullable(true).max(255).label("Subject"),
            typeId: yup.number().required().nullable(true).label("Type"),
        });
    }
}



// WEBPACK FOOTER //
// ./src/forms/adminEmailTemplate/Template.ts